import * as AdaptiveCards from 'adaptivecards';
class OutlookHostConfig extends AdaptiveCards.HostConfig {
    cardHorizontalAlignment?: string;
    cardMaximumWidth?: string;
    cardHostBackgroundColor?: string;

    constructor(hostConfig: OutlookHostConfig) {
        super(hostConfig);
        this.cardHorizontalAlignment = hostConfig.cardHorizontalAlignment;
        this.cardMaximumWidth = hostConfig.cardMaximumWidth;
        this.cardHostBackgroundColor = hostConfig.cardHostBackgroundColor;
    }
}

export default OutlookHostConfig;
